import api from "../http-request";

export const getListFeaturePageApi = async () => api.get(`api/list-feature-page`);

export const detailFeaturePageApi = async (id) => api.get(`api/detail/${id}/feature`);

export const getFeatureOfAreaGroupApi = async (id) => api.get(`api/detail/${id}/feature-area`);